import type { ProgressiveSentenceNotesData } from './useProgressiveSentenceNotesData.types';
import type { ProgressiveSentenceNotesArgs } from './useProgressiveSentenceNotes.types';
import type { LoaderProps } from '@compliance.ai/web-components';

import type { useProgressiveSentenceNotesQueries } from './useProgressiveSentenceNotesQueries';

import * as elements from './elements';
import * as constants from './useProgressiveSentenceNotes.constants';

export const useProgressiveSentenceNotesLoader = ({
  args,
  localState,
  formattedData,
  queries
}: {
  args: Pick<ProgressiveSentenceNotesArgs, 'type' | 'loaderProps'>;
  localState: ProgressiveSentenceNotesData['localState'];
  formattedData: ProgressiveSentenceNotesData['formattedData'];
  queries: ReturnType<typeof useProgressiveSentenceNotesQueries>;
}) => {
  switch (true) {
    case queries.fetchSentenceNoteById.isFetching: {
      return (
        <elements.Loader
          {...(args.loaderProps as Required<LoaderProps>)}
          text={`Loading selected ${args.type}`}
          progress={0}
        />
      );
    }

    case queries.fetchSentenceNotes.isFetching: {
      return (
        <elements.Loader
          {...(args.loaderProps as Required<LoaderProps>)}
          text={
            !localState.isInitialFetchOfList &&
            `You're viewing ${formattedData.sentenceNotes.length} of ${localState.totalCount}`
          }
          messages={constants.LOADER_MESSAGES[args.type]}
          progress={formattedData.progress}
        />
      );
    }

    case queries.fetchSystemGeneratedSentenceNotes.isFetching: {
      return (
        <elements.Loader
          {...(args.loaderProps as Required<LoaderProps>)}
          text="Loading system-generated obligations"
        />
      );
    }

    default: {
      return null;
    }
  }
};
